import {
  isBookingPersistenceError,
  isBookingPersistenceErrorHandled,
  resolveBookingPersistenceErrorMessage,
} from "./booking";

export const getUnhandledBookingRejectionContext = (event) => {
  const error = event?.reason;
  if (!isBookingPersistenceError(error)) {
    return null;
  }

  if (isBookingPersistenceErrorHandled(error)) {
    return null;
  }

  return {
    error,
    message: resolveBookingPersistenceErrorMessage(error),
  };
};
